/* Cadeau bij aankoop (Multi-Solar). Hoort bij snippets/mts-pdp-cadeau.liquid.
   Zodra een meetellende variant van dit product in de winkelwagen is gelegd, gaat het cadeauproduct
   automatisch mee (1×). De prijs €0 komt van de automatische korting "Koop X, krijg Y" in Shopify. */
(function () {
  const blok = document.querySelector('[data-mts-cadeau]');
  if (!blok || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  const cadeauVariant = Number(blok.dataset.cadeauVariant);
  const productId = Number(blok.dataset.productId);
  const uitgesloten = (blok.dataset.uitgesloten || '')
    .split(',')
    .map((s) => Number(s.trim()))
    .filter(Boolean);
  if (!cadeauVariant || !productId) return;

  // Blok verbergen als de bezoeker een variant kiest die niet meetelt (bv. losse module).
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const variant = event && event.data && event.data.variant;
    if (!variant) return;
    blok.hidden = uitgesloten.includes(Number(variant.id));
  });

  let bezig = false;
  subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
    if (!event || event.source !== 'product-form' || bezig) return;
    const toegevoegd = Number(event.productVariantId);
    if (!toegevoegd || toegevoegd === cadeauVariant || uitgesloten.includes(toegevoegd)) return;
    const regel = event.cartData && (event.cartData.items ? event.cartData.items[0] : event.cartData);
    if (!regel || Number(regel.product_id) !== productId) return;

    bezig = true;
    try {
      const cart = await fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const alIn = (cart.items || []).some((i) => Number(i.variant_id) === cadeauVariant);
      if (alIn) return;

      const res = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: cadeauVariant, quantity: 1 }),
      }).then((r) => r.json());
      if (res.status) return; // fout (bv. uitverkocht): stil overslaan, korting blijft geldig als klant het zelf toevoegt

      // Lade opnieuw renderen met een verse sectie-render: de secties uit het add-antwoord lopen
      // achter op automatische kortingen (totaal zou dan €108 te hoog staan).
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.getSectionsToRender === 'function' && typeof drawer.renderContents === 'function') {
        const ids = drawer.getSectionsToRender().map((s) => s.id).join(',');
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const sections = await fetch(`${root}?sections=${ids}`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
        drawer.renderContents({ id: cadeauVariant, sections });
      } else if (document.body.classList.contains('template-cart')) {
        window.location.reload();
      }
    } catch (e) {
      console.warn('mts-cadeau', e);
    } finally {
      bezig = false;
    }
  });
})();
